import User from "../../models/user";
import EconActivity from "../../models/econActivity";
import Business from "../../models/business";
import FinantialAccount from "../../models/finantialAccount";
import Subscription from "../../models/subscription";

const state = {
    user: User,
    defaultActivity: EconActivity,
    business: Business,
    hasDevices: false,
    finantialAccounts: [FinantialAccount],
    subscription: null,
};

const getters = {
    isAuthenticated: (state) => !!state.user.username || !!state.user.email,
    defaultActivity: (state) => state.defaultActivity,
    business: (state) => state.business,
    getUser: (state) => state.user,
    hasDevices: (state) => state.hasDevices,
    finantialAccounts: (state) => state.finantialAccounts,
    subscription: (state) => state.subscription,
};

const actions = {
    async Login({commit}, user) {
        await commit("setUser", user);
    },
    async Logout({ commit }) {
        await commit("logout");
    },
    async setDefaultActivity({commit}, activity) {
        await commit("setDefaultActivity", activity);
    },
    async setBusiness({commit}, business) {
        await commit("setBusiness", business);
    },
    async setDevices({commit}, value) {
        await commit("setDevices", value);
    },
    async setFinantialAccounts({commit}, value) {
        await commit("setFinantialAccounts", value);
    },
    async setSubscription({commit}, subscription) {
        await commit("setSubscription", subscription);
    }
};

const mutations = { 
    setUser(state, user) {
        state.user = new User(user);
    },

    logout(state) {
        state.user = new User(undefined);
        state.subscription = null;
    },
    
    setDefaultActivity(state, activity) {
        state.defaultActivity = new EconActivity(activity);
    },

    setBusiness(state, business) {
        state.business = new Business(business);
    },

    setDevices(state, value) {
        state.hasDevices = value;
    },

    setFinantialAccounts(state, value) {
        state.finantialAccounts = value;
    },

    setSubscription(state, subscription) {
        state.subscription = subscription ? new Subscription(subscription) : null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};